import React from 'react'
import { connect } from 'react-redux'

import * as actions from 'state/actions/CMT/ClanManagement'
import * as membersOperationActions from 'state/actions/CMT/MembersOperation'
import { showDialog, hideDialog } from 'state/actions/CMT/Dialog'
import requestMembersStatus from 'state/actions/clan_members_online'

import ClanManagement from '../components/ClanManagement/ClanManagement'
import ChangeCommanderDialog from '../components/Dialogs/ChangeCommander'
import RemoveMembersDialog from '../components/Dialogs/RemoveMembers'
import AllocatingResourcesDialog from '../components/Dialogs/AllocatingResources/AllocatingResources'
import ChangeRoleDialog from '../components/Dialogs/ChangeRole/ChangeRole'

const mapStateToProps = (state) => {
    const members = state.members.members
    const currentMember = members.find(member => member.id === state.account.id)
    const { membersOnline, membersTotal } = state.clanMembersOnline

    return {
        currentMemberId: state.account.id,
        currentMemberRole: currentMember && currentMember.role,
        isError: state.clanManagement.isError,
        isFetching: state.clanManagement.fetchingCounter > 0,
        clanTransactionInProcessing: state.clanManagement.transactionInProcessing,
        blockType: state.clanManagement.blockType,
        statisticsType: state.members.statisticsType,
        statistics: state.members.statistics,
        blockState: state.clanManagement[state.clanManagement.blockType],
        clan: state.clan,
        members,
        membersOnline,
        membersTotal,
        tableHeadersSorting: state.members.sorting,
        membersOperation: state.membersOperation,
        canSeeTreasury: state.account.permissions.see_treasury,
        showClanQuestsCard: state.settings.showClanQuestsCard,
        isCNRealm: state.settings.isCNRealm,
        isGlobalMapEnabled: !!state.settings.globalMapUrl,
    }
}

const mapDispatchToProps = (dispatch) => ({
    fetchData: (withGlobalSpinner) => dispatch(actions.fetchClanInfo(withGlobalSpinner)),
    openInvitesApplicationsWindow: () => dispatch(actions.openInvitesApplicationsWindow()),
    showChangeCommanderDialog: (selectedMember) => {
        const dialog = (
            <ChangeCommanderDialog
                isOpened
                selectedMemberName={selectedMember.name}
                onSubmit={() => {
                    dispatch(membersOperationActions.changeCommander(selectedMember.id))
                    dispatch(hideDialog())
                }}
                onClose={() => dispatch(hideDialog())}
            />
        )
        dispatch(showDialog(dialog))
    },
    showRemoveMembersDialog: (selectedMembers, memberId) => {
        const dialog = (
            <RemoveMembersDialog
                isOpened
                selectedMembers={selectedMembers}
                onSubmit={() => {
                    dispatch(membersOperationActions.removeMembers(memberId))
                    dispatch(hideDialog())
                }}
                onClose={() => dispatch(hideDialog())}
            />
        )
        dispatch(showDialog(dialog))
    },
    showAllocatingResourcesDialog: (member) => {
        const dialog = (
            <AllocatingResourcesDialog
                isOpened
                selectedMembers={member && [member]}
                onSubmit={(amountToEach, currency) => {
                    dispatch(membersOperationActions.allocateResources(amountToEach, currency, member && member.id))
                    dispatch(hideDialog())
                }}
            />
        )
        dispatch(showDialog(dialog))
    },
    showChangeRoleDialog: (member) => {
        const dialog = (
            <ChangeRoleDialog
                isOpened
                selectedMembers={member && [member]}
                onSubmit={() => {
                    dispatch(membersOperationActions.changeRole(member && member.id))
                    dispatch(hideDialog())
                }}
            />
        )
        dispatch(showDialog(dialog))
    },
    onChangeBlockType: (clanTransactionInProcessing, blockType) => {
        dispatch(actions.changeBlockType(blockType))
        if (!clanTransactionInProcessing) {
            dispatch(actions.fetchClanInfo())
        }
    },
    onChangePeriod: (clanTransactionInProcessing, period) => {
        dispatch(actions.changePeriod(period))
        if (!clanTransactionInProcessing) {
            dispatch(actions.fetchClanInfo())
        }
    },
    onChangeBattleType: (clanTransactionInProcessing, battleType) => {
        dispatch(actions.changeBattleType(battleType))
        if (!clanTransactionInProcessing) {
            dispatch(actions.fetchClanInfo())
        }
    },
    onChangeRandomBattleType: (clanTransactionInProcessing, randomBattleType) => {
        dispatch(actions.changeRandomBattleType(randomBattleType))
        if (!clanTransactionInProcessing) {
            dispatch(actions.fetchClanInfo())
        }
    },
    onToggleMemberTick: (memberId) => dispatch(membersOperationActions.toggleMemberTick(memberId)),
    onResetSelectedMembers: () => dispatch(membersOperationActions.resetSelectedMembers()),
    onTableHeaderClick: (header) => dispatch(membersOperationActions.sortMembers(header)),
    onTickAllMembers: (membersIds) => dispatch(membersOperationActions.toggleAllMembersTick(membersIds)),
    requestMembersStatus: () => dispatch(requestMembersStatus()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ClanManagement)



// WEBPACK FOOTER //
// ./containers/ClanManagement/containers/ClanManagement.js